import classnames from "classnames";
import { isUndefined } from "lodash";
import * as React from "react";

export interface TabContentProps {
  isDisabled?: boolean;
  isVisible?: boolean;
  children?: any;
  isActive?: boolean;
}

export default ({ isActive, isDisabled, children, isVisible }: TabContentProps) => (
  <div
    className={classnames("tab-pane", {
      active: isActive,
      disabled: isDisabled,
      none: !isUndefined(isVisible) && !isVisible
    })}
  >
    {children}
  </div>
);
